// extracted by mini-css-extract-plugin
module.exports = {"balance-detail":"balance-detail--28QoJ","label":"label--1LuJa","drop":"drop--3D4Rj"};